import React, { useEffect, useMemo, useState } from "react";
import "./styles.css";
import { Sheet } from "../../Templates";
import { Spinner } from "@chakra-ui/react";
import { MODULE_TYPES, WIDGET_TYPES } from "../../Library/widgets";
import { getDealersAndDevices, getSellerDealers } from "../../APIs";
import { DRAWER_ACCESS_CODES } from "../../Library/constants";
import { HeaderWallet } from "../../Components/Atoms";

const DealersOverview = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ statistics, setStatistics ] = useState(null);
  const [ dashboardLayout, setDashboardLayout ] = useState([]);

  const ACCESS_CODES = useMemo(() => JSON.parse(window.localStorage.getItem("accessCodes")), []);

  const createOEMCharts = () => {
    getSellerDealers((err, data) => {
      if (err) {
        console.error(err);
        setStatistics({});
        setIsLoading(false);
      } else {
        if (data && data.length) {
          data.forEach((device, idx) => {
            device.total = (device.stock || 0) + (device.installed || 0);
            device.idx = idx + 1;
          });

          const processData = (sortedArray, key) => {
            let dataArray = [];
            let others = { nm: "Others", cnt: 0 };

            if (sortedArray.length > 3) {
              let extras = sortedArray.splice(3);
              extras.forEach(dev => {
                others.cnt += (dev[key] || 0);
              });
            }

            sortedArray.forEach(dev => {
              dataArray.push({
                nm: dev.nm,
                cnt: dev[key] || 0,
                idx: dev.idx
              });
            });

            if (others.cnt > 0) {
              dataArray.push(others);
            }

            return dataArray;
          };

          const sortedInstalled = [...data].sort((a, b) => b.installed - a.installed);
          const sortedInstock = [...data].sort((a, b) => b.stock - a.stock);
          const sortedTotal = [...data].sort((a, b) => b.total - a.total);

          let installedData = processData(sortedInstalled, 'installed');
          let instockData = processData(sortedInstock, 'stock');
          let totalData = processData(sortedTotal, 'total');

          setStatistics({
            [MODULE_TYPES.ALL_DEVICES]: {
              one: totalData,
              two: installedData,
              three: instockData,
              count: (data || []).length,
            },
          });
          setIsLoading(false);
        } else setIsLoading(false);
      }
    });
  }

  const createDealershipCharts = () => {
    getDealersAndDevices(null, (err, data) => {
      if (err) {
        console.error(err);
      } else {
        const MAX_CHART_ELEMS = 6;
        let statistics = data;

        let processDevices = (devices) => {
          devices = devices.sort((a, b) => (b.stock + b.installed) - (a.stock + a.installed));
          let processedArr = [];
          if (devices.length > 6) {
            let othersTotalStock = 0;
            let othersTotalInstalled = 0;
            devices.forEach((dev, idx) => {
              if ((idx + 1) < MAX_CHART_ELEMS) {
                processedArr.push(dev);
              } else {
                othersTotalStock += dev.stock;
                othersTotalInstalled += dev.installed;
                if (idx === devices.length - 1) {
                  processedArr.push({ idx: -1, nm: "Others", stock: othersTotalStock, installed: othersTotalInstalled });
                }
              }
            });
            return processedArr;
          }
          return devices;
        };

        let stock = processDevices(statistics);
        let installed = processDevices(statistics);

        stock = stock.map(dev => {
          return { ...dev, count: dev.stock };
        });

        installed = installed.map(dev => {
          return { ...dev, count: dev.installed };
        });

        let arr = [];
        for (let i = 0; i < (stock.length || installed.length); i++) {
          let total = (stock[i] && stock[i].stock ? stock[i].stock : 0) + (installed[i] && installed[i].installed ? installed[i].installed : 0);
          arr.push({ idx: (stock[i] || installed[i]).idx, nm: (stock[i] || installed[i]).nm, count: total });
        }

        setStatistics({ [MODULE_TYPES.ALL_DEVICES]: { stock: stock, installed: installed, total: arr } });
      }

      setIsLoading(false);
    });
  }

  useEffect(() => {
    const DEALERS_DASHBOARD_LAYOUT = [];
    // if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.DEALER_MANAGEMENT)) {
    //     DEALERS_DASHBOARD_LAYOUT.push([WIDGET_TYPES.ALL_DEVICES]);

    //     if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.ORDERS_OVERVIEW)) { // need last order and wallet in same row
    //         DEALERS_DASHBOARD_LAYOUT.unshift([WIDGET_TYPES.WALLET, WIDGET_TYPES.LAST_ORDER]);
    //     }
    // } else if (ACCESS_CODES.includes(401)) {
    //     DEALERS_DASHBOARD_LAYOUT.unshift([WIDGET_TYPES.LAST_ORDER]);
    // }

    if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.ORDERS_OVERVIEW)) DEALERS_DASHBOARD_LAYOUT.push([WIDGET_TYPES.ORDER_HISTORY]);
    if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW)) DEALERS_DASHBOARD_LAYOUT.push([WIDGET_TYPES.SHIPMENT_HISTORY]);
    if (ACCESS_CODES.includes(DRAWER_ACCESS_CODES.DEALER_MANAGEMENT)) DEALERS_DASHBOARD_LAYOUT.push([WIDGET_TYPES.ALL_DEVICES]);


    // createDealershipCharts();
    if (DEALERS_DASHBOARD_LAYOUT.length) setDashboardLayout(DEALERS_DASHBOARD_LAYOUT);
    createOEMCharts();
  }, [ ACCESS_CODES ]);


  return (
    <section className="panel-main seller-dashboard">
      <header className="wallet-header">
        <HeaderWallet />
      </header>
      <main>
        {(!isLoading) ? (statistics ? <Sheet layout={dashboardLayout} data={statistics} /> : <p className="empty-dashboard-msg">No orders or shipmets to show</p>) : (
          <div className="widget-loader">
            <Spinner />
          </div>
        )}
      </main>
    </section>
  )
}

export default DealersOverview
